'use client';

import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export function MissionStatementModal({
  isOpen,
  onClose,
  initialStatement,
  onSave,
}) {
  const [statement, setStatement] = useState(initialStatement || '');

  const handleChange = (e) => {
    setStatement(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(statement);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] bg-zinc-900 border-white/10 text-white">
        <DialogHeader>
          <DialogTitle className="text-white">
            Edit Mission Statement
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="missionStatement" className="text-zinc-300">
                Mission Statement
              </Label>
              <Textarea
                id="missionStatement"
                value={statement}
                onChange={handleChange}
                placeholder="Enter your organization's mission statement"
                rows={6}
                className="font-serif text-lg bg-black border-white/10 text-white placeholder:text-zinc-600 focus:border-purple-500"
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="border-white/10 text-zinc-300 hover:text-white hover:bg-white/5"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-purple-600 hover:bg-purple-700 text-white"
            >
              Save changes
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
